import {
  INSTANCE_DASHBOARD_READ,
  INSTANCE_DASHBOARD_DELETE,
  INSTANCE_DASHBOARD_UPDATE_STATUS,
  INSTANCE_SETTINGS_UPDATE_SUCCESS,
} from 'client/redux/instance/constants';
import { reduceByTypes } from 'client/redux/apiHelpers';
import _ from 'lodash';

const defaultState = {
  isReading: false,
  isDeleting: false,
  isUpdating: false,
  instance: null,
  connector: null,
  endpointsByType: null,
  optionalEndpoints: [],
  logs: null,
  plan: null,
  subscription: null,
  isParentInstance: false,
};

export default function dashboardReducer (state = defaultState, action) {
  state = reduceByTypes(INSTANCE_DASHBOARD_READ, state, action, {
    requestProp: 'isReading',
    successProp: (currentState, actionObject) => {
      // Access the actual payload nested within the action object
      const apiPayload = actionObject.payload; 
      if (!apiPayload) { 
        return {}; // Return empty update if payload is missing
      }

      const update = _.pick(apiPayload, [ // Pick from apiPayload
        'instance',
        'connector',
        'endpointsByType',
        'logs',
        'plan',
        'subscription',
        'isParentInstance',
        'optionalEndpoints',
      ]);
      update.instance = update.instance || null;
      update.endpointsByType = update.endpointsByType || {};
      return update;
    },
  });

  state = reduceByTypes(INSTANCE_DASHBOARD_UPDATE_STATUS, state, action, {
    requestProp: 'isUpdating',
    successSpread: true,
    successPickProps: ['instance'],
  });
  state = reduceByTypes(INSTANCE_DASHBOARD_DELETE, state, action, {
    requestProp: 'isDeleting',
    successSpread: true,
    successPickProps: [],
  });

  if (action.type === INSTANCE_SETTINGS_UPDATE_SUCCESS) {
    const updatedInstance = _.get(action, 'payload.instance', null);
    const updatedInstanceId = _.get(updatedInstance, 'id', null);
    if (!updatedInstance || !state.instance || updatedInstanceId !== _.get(state, 'instance.id', null)) {
      return state;
    }

    return {
      ...state,
      instance: {
        ...state.instance,
        ...updatedInstance,
        settings: _.get(updatedInstance, 'settings', _.get(state, 'instance.settings', {})),
      },
    };
  }

  return state;
}
